<template>
  <path
    id="ic_gavel_24px"
    d="M1,35.557H21.737v3.456H1ZM8.337,13.216l4.89-4.885L37.66,32.767l-4.887,4.886ZM20.557,1l9.775,9.773-4.89,4.89-9.77-9.78ZM5.884,15.661l9.775,9.775-4.887,4.886L1,20.547Z"
    transform="translate(-0.997 -1)" />
</template>
